export const API_PREFIX_PATH = "/admin/v1";
export const zeroDate = "0001-01-01T00:00:00Z";
export const currentYear = new Date().getFullYear();
export const HEADER_HEIGHT = 67;
export const defaultApplication = {
  application_id: "",
  borrower: "",
  co_borrowers: [],
  los_id: "",
  application_status: "",
  loan_amount: 0,
  total_amount: 0,
  down_payment_amount: 0,
  estimated_monthly_payment: 0,
  interest_rate: 0,
  application_date: "",
  last_updated_at: "",
  property_address: "",
  property_city: "",
  property_state: "",
  property_zip: "",
  target_delivery_date: "",
  target_funding_date: "",
  section_type: "SINGLE_WIDE" as
    | "SINGLE_WIDE"
    | "DOUBLE_WIDE"
    | "TRIPLE_WIDE"
    | "QUAD_WIDE",
  sales_rep: "",
  team_members: [],
};
